import React from "react";

import GridLayout from "@components/WorkShowcase/WorkGrid";
import Rule from "@components/Rule";

import { css } from "@oddcommon/utils";
import styles from "./RelatedProjects.module.scss";

export default function RelatedProjects({ projects, className, ...props }) {
  return (
    <section className={css(styles.base, className)} {...props}>
      <header>
        <Rule className={styles.rule}>Up next</Rule>
        <h2>Related Projects</h2>
      </header>
      <GridLayout oneRow items={projects} />
    </section>
  );
}
